var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"survey-app"},[_c(_vm.currentComponent,_vm._b({tag:"component",attrs:{"survey":_vm.survey},on:{"accept":_vm.handleAcceptTerms,"continue":_vm.handleStartSurvey,"start":_vm.handleStartQuestions,"complete":_vm.handleComplete,"back":_vm.handleBack}},'component',_vm.currentComponentProps,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fea7c70a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cultura/views/Survey.vue
// module id = 1986
// module chunks = 2